import * as Styled from './Flyout.styles'

import React, { forwardRef } from 'react'

import { FlyoutProps } from './Flyout.types'
import useFlyout from './useFlyout'

const Flyout = forwardRef<HTMLElement, FlyoutProps>((props, ref) => {
	const { id, isOpen, onClose, children } = props
	useFlyout(id, isOpen, onClose)
	return (
		<Styled.Flyout
			aria-hidden={!isOpen}
			id={id}
			isOpen={isOpen}
			ref={ref}
			{...props}
		>
			{children}
		</Styled.Flyout>
	)
})

Flyout.displayName = 'Flyout'

export default Flyout
